<template>
  <div :class="$style.container">
    <img v-if="preview" :class="$style.image" :src="imageSrc" />
    <div v-else :class="$style.input">
      <label :class="$style.input__image">
        <img :class="$style.image" :src="imageSrc" />
        <input
          :class="$style.input__input"
          type="file"
          accept="image/jpeg, image/png"
          :value="null"
          @input="handleInput"
        />
      </label>
      <ul :class="$style.actions">
        <li :class="$style.actions__item">
          <label :class="$style.action">
            変更する
            <input
              :class="$style.action__input"
              type="file"
              accept="image/jpeg, image/png"
              :value="null"
              @input="handleInput"
            />
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import DefaultAvatar from '@/assets/images/no-image-planner.png'

const props = withDefaults(
  defineProps<{
    avatarImageSrc?: Maybe<string>
    preview: boolean
  }>(),
  {
    avatarImage: undefined,
    preview: false,
  }
)

const emit = defineEmits<{
  (event: 'input', value: File): void
}>()

const imageSrc = computed(() => props.avatarImageSrc ?? DefaultAvatar)

const handleInput = (event: Event): void => {
  if (!(event.target instanceof HTMLInputElement)) {
    return
  }

  const [file] = event.target.files ?? []
  if (!file) {
    return
  }

  emit('input', file)
}
</script>

<style lang="scss" module>
$thumbnail-size: 100px;

.image {
  width: $thumbnail-size;
  height: $thumbnail-size;
}

.input {
  display: grid;
  align-items: center;
  grid-template-columns: $thumbnail-size 1fr;

  &__input {
    display: none;
  }

  &__image {
    cursor: pointer;
    transition: opacity $transition-interaction;

    &:hover {
      opacity: 0.7;
    }
  }
}

.actions {
  &__item {
    text-align: right;

    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }
}

.action {
  display: inline-flex;
  padding: 0;
  appearance: none;
  color: $color-text-and-object-accent-primary;
  font-size: 14px;

  &:hover {
    color: $color-text-and-object-accent-primary;
    cursor: pointer;
    text-decoration: underline;
  }

  &__input {
    display: none;
  }
}
</style>
